export const LEGEND_SET_STATE = '@legend/LEGEND_SET_STATE';
export const LEGEND_UPDATE_STATE = '@legend/LEGEND_UPDATE_STATE';
//# sourceMappingURL=constants.js.map